import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TRequest {
  id: number;
  reportingPeriodApplicantId: number;
  requestTypeCode: string;
  name: string;
  content?: string;
  priority: number;
  read: boolean;
  valid: boolean;
  validFrom: Date;
  validTo?: Date;
  requestTypeName: string;
  reportingPeriodName: string;
}

export interface IRequest extends TRequest {}

const Request = Model(
  (model: TRequest): IRequest => {
    const _request: TRequest = Object.assign({}, model);

    let create = (Request: IRequest): IRequest => {
      let obj = ValidatableObject(Request);
      return obj;
    };

    let request = {
      get id() {
        return _request.id;
      },
      set id(value) {
        _request.id = value;
      },
      get name() {
        return _request.name;
      },
      set name(value) {
        _request.name = value;
      },
      get reportingPeriodApplicantId() {
        return _request.reportingPeriodApplicantId;
      },
      set applicantId(value) {
        _request.reportingPeriodApplicantId = value;
      },
      get content() {
        return _request.content;
      },
      set content(value) {
        _request.content = value;
      },
      get priority() {
        return _request.priority;
      },
      set priority(value) {
        _request.priority = value;
      },
      get read() {
        return _request.read;
      },
      set read(value) {
        _request.read = value;
      },
      get requestTypeCode() {
        return _request.requestTypeCode;
      },
      set requestTypeCode(value) {
        _request.requestTypeCode = value;
      },
      get valid() {
        return _request.valid;
      },
      set valid(value) {
        _request.valid = value;
      },
      get validFrom() {
        return _request.validFrom;
      },
      set validFrom(value) {
        _request.validFrom = value;
      },
      get validTo() {
        return _request.validTo;
      },
      set validTo(value) {
        _request.validTo = value;
      },
      get requestTypeName() {
        return _request.requestTypeName;
      },
      get reportingPeriodName() {
        return _request.reportingPeriodName;
      }
    };

    return create(request);
  }
);

export default Request;
